// TODO: From App New
<template>
  <b-card>
    <template #header>
      <div class="d-flex justify-content-between align-items-start w-100">
        <div>
          <h5 class="mb-0">
            Brand Terpilih
          </h5>
          <small class="text-muted">Brand yang akan diikutsertakan dalam promo</small>
        </div>
        <b-badge
          variant="light-success"
          class="flex-shrink-0"
        >
          {{ selectedBrands.length }} Brand
        </b-badge>
      </div>
    </template>

    <!-- Search Input -->
    <div class="mb-2">
      <b-input-group class="input-group-merge position-relative">
        <b-input-group-prepend is-text>
          <feather-icon icon="SearchIcon" />
        </b-input-group-prepend>

        <b-form-input
          v-model="searchKeyword"
          placeholder="Cari brand terpilih..."
          @input="handleSearch"
        />

        <b-input-group-append
          v-if="searchKeyword"
          is-text
          class="cursor-pointer"
          @click="resetSearch"
        >
          <feather-icon icon="XIcon" />
        </b-input-group-append>
      </b-input-group>
    </div>

    <!-- Loading State -->
    <div
      v-if="loading"
      class="selected-brands-list d-flex align-items-center justify-content-center"
    >
      <div class="text-center py-4">
        <b-spinner variant="primary" />
        <p class="text-muted mt-2 mb-0">
          Memuat brand terpilih...
        </p>
      </div>
    </div>

    <!-- Selected Brands List -->
    <div
      v-else-if="filteredBrands.length > 0"
      class="selected-brands-list"
    >
      <div
        v-for="brand in paginatedBrands"
        :key="`selected-${brand.id}`"
        class="selected-brand-item d-flex align-items-center p-2 border rounded mb-1"
      >
        <!-- Brand Image -->
        <div class="brand-image mr-3">
          <b-avatar
            :src="brand.image_url"
            :text="brand.name.charAt(0)"
            size="40"
            variant="light-success"
          />
        </div>

        <!-- Brand Info -->
        <div class="flex-grow-1">
          <h6 class="mb-0">
            {{ brand.name }}
          </h6>
          <small class="text-muted">{{ brand.slug }}</small>
        </div>

        <!-- Action Buttons -->
        <div class="d-flex">
          <!-- Setup Button (Primary Action) -->
          <b-button
            size="sm"
            variant="primary"
            @click="$emit('setup-price', brand)"
          >
            Setup Harga
          </b-button>

          <!-- More Actions Dropdown (Secondary Action) -->
          <b-dropdown
            size="sm"
            variant="outline-secondary"
            no-caret
            right
            class="ml-1"
          >
            <template #button-content>
              <feather-icon
                icon="MoreHorizontalIcon"
                size="14"
              />
            </template>

            <b-dropdown-item @click="$emit('share-url', brand)">
              <feather-icon
                icon="ShareIcon"
                size="14"
                class="mr-2"
              />
              Share URL
            </b-dropdown-item>

            <b-dropdown-item
              variant="danger"
              @click="$emit('remove-brand', brand)"
            >
              <feather-icon
                icon="TrashIcon"
                size="14"
                class="mr-2"
              />
              Hapus
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>

    <!-- Pagination (Outside scroll area) -->
    <div
      v-if="totalBrands > 0"
      class="mt-2 px-1"
    >
      <b-form-row class="align-items-center mb-1">
        <!-- Per page selector -->
        <b-col cols="auto">
          <small class="text-muted">Rows per page:</small>
        </b-col>
        <b-col cols="auto">
          <b-form-select
            :value="perPage"
            :options="perPageOptions"
            size="sm"
            @input="changePerPage"
          />
        </b-col>

        <!-- Row count display -->
        <b-col
          cols="auto"
          class="mx-1"
        >
          <small class="text-muted">
            {{ startRowNumber }}-{{ endRowNumber }} of {{ totalBrands }}
          </small>
        </b-col>

        <!-- Pagination component -->
        <b-col>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalBrands"
            :per-page="perPage"
            align="right"
            size="sm"
            class="mb-0"
          />
        </b-col>
      </b-form-row>
    </div>

    <!-- Empty State for No Selected Brands -->
    <div
      v-else-if="!loading && selectedBrands.length === 0"
      class="selected-brands-list d-flex align-items-center justify-content-center"
    >
      <div class="text-center py-4">
        <feather-icon
          icon="PackageIcon"
          size="48"
          class="text-muted mb-2"
        />
        <p class="text-muted mb-0">
          Belum ada brand yang dipilih
        </p>
        <small class="text-muted">
          Pilih brand dari daftar di sebelah kanan untuk diikutsertakan dalam promo
        </small>
      </div>
    </div>

    <!-- Empty State for Search Results -->
    <div
      v-else-if="!loading"
      class="selected-brands-list d-flex align-items-center justify-content-center"
    >
      <div class="text-center py-4">
        <feather-icon
          icon="SearchIcon"
          size="48"
          class="text-muted mb-2"
        />
        <p class="text-muted mb-0">
          Tidak ada brand terpilih yang ditemukan
        </p>
        <small class="text-muted">
          Coba kata kunci yang berbeda
        </small>
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BBadge,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
  BFormInput,
  BAvatar,
  BButton,
  BSpinner,
  BPagination,
  BFormRow,
  BCol,
  BFormSelect,
  BDropdown,
  BDropdownItem,
} from 'bootstrap-vue'

export default {
  name: 'SaleBrandsSelected',
  components: {
    BCard,
    BBadge,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BFormInput,
    BAvatar,
    BButton,
    BSpinner,
    BPagination,
    BFormRow,
    BCol,
    BFormSelect,
    BDropdown,
    BDropdownItem,
  },
  props: {
    selectedBrands: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['setup-price', 'share-url', 'remove-brand'],
  data() {
    return {
      searchKeyword: '',
      // Pagination
      perPage: 10,
      currentPage: 1,
      perPageOptions: [
        { value: 3, text: 3 },
        { value: 5, text: 5 },
        { value: 10, text: 10 },
        { value: 20, text: 20 },
      ],
    }
  },
  computed: {
    filteredBrands() {
      if (!this.searchKeyword) {
        return this.selectedBrands
      }

      const keyword = this.searchKeyword.toLowerCase()
      return this.selectedBrands.filter(brand => brand.name.toLowerCase().includes(keyword)
        || brand.slug.toLowerCase().includes(keyword))
    },
    totalBrands() {
      return this.filteredBrands.length
    },
    paginatedBrands() {
      const start = (this.currentPage - 1) * this.perPage
      const end = start + this.perPage
      return this.filteredBrands.slice(start, end)
    },
    startRowNumber() {
      if (this.totalBrands === 0) return 0
      return (this.currentPage - 1) * this.perPage + 1
    },
    endRowNumber() {
      const end = this.currentPage * this.perPage
      return end > this.totalBrands ? this.totalBrands : end
    },
  },
  methods: {
    handleSearch() {
      // Reset to first page when search
      this.currentPage = 1
    },
    resetSearch() {
      this.searchKeyword = ''
      this.currentPage = 1
    },
    changePerPage(perPage) {
      this.perPage = perPage
      this.currentPage = 1 // Reset to first page
    },
  },
}
</script>

<style scoped>
.feather-icon {
  opacity: 0.5;
}

.cursor-pointer {
  cursor: pointer;
}

/* .selected-brands-list {
  max-height: 400px;
  overflow-y: auto;
} */

.selected-brand-item {
  transition: all 0.2s ease;
}
</style>
